import { FiltersToolbar } from "@components/commerce/product-listing/filters/toolbar/FiltersToolbar";
import type { IPartFilter, IPartStoryTile } from "@contentful-api/types/contentful";
import { Box } from "@ui/components/layout/box/Box";
import { sizes } from "@ui/design-tokens";
import type { FC } from "react";
import { ProductList } from "./product-tile-list/ProductList";
import { useFilterStore } from "@store/filterStore";
import { Flex } from "@ui/components/layout/flex/Flex";
import SortBy from "@components/commerce/product-listing/filters/toolbar/item/sortBy/SortBy";
import { useThemeMediaQuery } from "@ui/hooks/useThemeMediaQuery";

interface IProductListingProps {
    listOfFilters: IPartFilter[];
    locale: string;
    widgetSize?: string;
    editorialWidgets?: IPartStoryTile[];
}

export const ProductListing: FC<IProductListingProps> = ({
    listOfFilters,
    locale,
    widgetSize,
    editorialWidgets,
}) => {
    const filtersDialogOpened = useFilterStore((state) => state.filtersDialogOpened);
    const { lg: isDesktopView } = useThemeMediaQuery();

    return (
        <Box data-testid="product-listing" position="relative">
            {/* SortBy - hidden on mobile, visible on desktop, non-sticky */}
            {isDesktopView && (
                <Box
                    position="absolute"
                    top={0}
                    mt={1}
                    right={0}
                    w="auto"
                    px={["layoutMargin.mobile", "layoutMargin.tab", "layoutMargin.desktop"]}
                    zIndex={filtersDialogOpened ? 4 : 3}
                >
                    <Flex justifyContent="flex-end" alignItems="center" height="60px">
                        <SortBy locale={locale} />
                    </Flex>
                </Box>
            )}
            <Box
                sx={{
                    position: "sticky",
                    w: "100%",
                    top: [
                        `calc(${sizes.navBarCollapsedHeight} + 25px)`,
                        `calc(${sizes.navBarCollapsedHeight} + 25px)`,
                        `calc(${sizes.navBarCollapsedHeight} + 35px)`,
                    ],
                    zIndex: filtersDialogOpened ? 3 : 2,
                    boxSizing: "border-box",
                    px: ["layoutMargin.mobile", "layoutMargin.tab", "layoutMargin.desktop"],
                }}
            >
                <FiltersToolbar listOfFilters={listOfFilters} locale={locale} />
            </Box>
            <Box sx={{ position: "relative" }}>
                <Box
                    sx={{
                        position: "relative",
                        display: "block",
                    }}
                >
                    <ProductList widgetSize={widgetSize} editorialWidgets={editorialWidgets} />
                </Box>
            </Box>
        </Box>
    );
};
